import api from '@/rest-api'
export default {
    getDealers() {
        return api.get('/dealer/all')
    },
    getDealerById(id) {
        return api.get(`/dealer/${id}`)
    },
    // dashboard figures of the logged-in dealer; filter: { from, to, partner, team } (all optional)
    getStats(filter) {
        return api.post('/dealer/stats', filter || {})
    }
}
